const UPDATE_PROJECT_INFO = 'scratch-gui/project-info/UPDATE_PROJECT_INFO';

const initialState = {
    project:{}
}

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_PROJECT_INFO:
        return Object.assign({}, state, action.data);
    default:
        return state;
    }
};

const updateProjectInfo = project => ({
    type: UPDATE_PROJECT_INFO,
    data: project
});

export {
    reducer as default,
    initialState as projectInfoInitialState,
    updateProjectInfo
};
